const title = '智慧收银系统'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js